import React, {Component} from 'react';
import { connect } from 'react-redux';

import SysadminFormsExcludedClinicAdd from '../../component/sysadmin/forms/excludedclinic';
import {
    submitSystemAdminCreateExcludedClinic
} from '../../actions';

class SysadminExcludedClinicAddPage extends Component {
    render() {
        return (
            <SysadminFormsExcludedClinicAdd 
                submitSystemAdminCreateExcludedClinic={this.props.submitSystemAdminCreateExcludedClinic}
                user={this.props.user}
            />
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user.user
    }
}

export default connect(mapStateToProps, {
    submitSystemAdminCreateExcludedClinic
})(SysadminExcludedClinicAddPage);